module.exports = __webpack_public_path__ + "static/media/SERIELUP.9631a304.jpg";